export const common = {
  // Navigation
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.services": "服务",
  "nav.products": "产品",
  "nav.certifications": "认证",
  "nav.partnerships": "合作伙伴",
  "nav.contact": "联系我们", 
  "nav.quote": "获取报价",
  
  // Common buttons
  "button.learnMore": "了解更多",
  "button.getQuote": "获取报价",
  "button.contactUs": "联系我们",
  "button.viewAll": "查看全部",
  "button.download": "下载",
  
  // Common text
  "company.name": "德力信集团",
  "company.tagline": "马来西亚棕榈油专家",
  "language.current": "中文"
};

export default common;